import TeamList from "../components/TeamList";

const ListTeamPage = () => {
  return (
    <TeamList />
  );
};

export default ListTeamPage;
